import {StyleSheet, View, Text, Platform, Animated} from 'react-native';
import React, {useEffect, useRef, useState} from 'react';
import {FONT_FAMILY_REGULAR, isWeb} from './utils';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../redux/slices/ScreenOrientationSlice';
import logger from './logger';

export const PaymentStepsView = props => {
   const completeSteps = props.completeSteps;
   logger('completeSteps ', {completeSteps}, false);
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const styles = style(isLandscapeMode);
   const [fadeAnim] = useState(new Animated.Value(1));
   useEffect(() => {
      // Fade out animation
      if (completeSteps >= 3) {
         Animated.timing(fadeAnim, {
            toValue: 0, // Fade out to completely transparent
            duration: 3000, // Duration of the animation in milliseconds
            useNativeDriver: true, // Use native driver for better performance
         }).start();
      }
   }, [completeSteps]);
   return (
      <Animated.View style={{opacity: completeSteps >= 3 ? fadeAnim : null}}>
         <View style={styles.container}>
            <View
               style={[
                  styles.circlerView,
                  {backgroundColor: completeSteps >= 1 ? '#003DA6' : '#A8A4A4'},
               ]}>
               <Text style={isWeb ? styles.textStyleweb : styles.textStyle}>
                  1
               </Text>
            </View>
            <View style={styles.lineStyle} />
            <View
               style={[
                  styles.circlerView,
                  {backgroundColor: completeSteps >= 2 ? '#003DA6' : '#A8A4A4'},
               ]}>
               <Text style={isWeb ? styles.textStyleweb : styles.textStyle}>
                  2
               </Text>
            </View>
            <View style={styles.lineStyle} />
            <View
               style={[
                  styles.circlerView,
                  {backgroundColor: completeSteps >= 3 ? '#003DA6' : '#A8A4A4'},
               ]}>
               <Text style={isWeb ? styles.textStyleweb : styles.textStyle}>
                  3
               </Text>
            </View>
         </View>
      </Animated.View>
   );
};

const style = isLandscapeMode =>
   StyleSheet.create({
      container: {
         flexDirection: 'row',
         marginTop: 24,
         marginBottom: 24,
      },
      circlerView: {
         backgroundColor: '#003DA6',
         width: 40,
         height: 40,
         alignItems: 'center',
         justifyContent: 'center',
         borderRadius: 20,
      },
      textStyle: {
         color: 'white',
         textAlign: 'center',
         textAlignVertical: 'center',
         fontSize: 20,
         fontWeight: '700',
         marginBottom:
            isWeb && isLandscapeMode ? 2 : Platform.OS === 'windows' ? 3 : 1,
      },
      textStyleweb: {
         color: 'white',
         textAlign: 'center',
         textAlignVertical: 'center',
         fontSize: 20,
         fontWeight: '700',
         lineHeight: 0,
         marginBottom: isWeb && isLandscapeMode ? 2 : 0,
      },
      lineStyle: {
         width: 70,
         height: 1.25,
         marginTop: 20,
         backgroundColor: '#A8A4A4',
      },
   });
